import React, { useMemo, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigateV2, useHistoryStore } from '../utils/router';
import UserContext, { PusherContext, UserProfileContext } from '../utils/getContext';
import { logOutFunction, rolesUrls } from '../utils/utils';
import { checkIsPartner, getUserRoles } from '../utils/memo';
import { usePusher } from '../utils/pusher.utills';
import CustomPasswordModal from '../../widgets/customPasswordModal/CustomPasswordModal';

const ProtectedAdmin = ({ children, role = [] }) => {
    const { userToken, lang, storageLoaded, setUserToken } = useContext(UserContext);
    const [roles, setRoles] = useState([]);

    const hasRoles = useMemo(
        () =>
            roles.some((item) =>
                [...(role || []), 'superadmin', 'admin'].some((r) => item.name === r || item.name.startsWith(`${r}::`))
            ),
        [roles, role]
    );

    const [loaded, setLoaded] = useState(false);
    const [profileData, setProfileData] = useState(false);
    const [newToken, setNewToken] = useState(false);

    const { pusherClient } = usePusher(loaded && userToken, lang);

    useEffect(() => {
        if (newToken) {
            setUserToken(newToken).finally(() => {
                navigateV2('/office');
            });
        }
    }, [newToken, setUserToken]);
    useEffect(() => {
        if (!newToken && storageLoaded) {
            if (!userToken) {
                navigateV2('/');
            } else {
                (async () => {
                    const { data, status } = (await getUserRoles(userToken, lang)) || {};
                    if (data) {
                        setRoles(data);
                        const hasRoles = data.some((item) =>
                            [...(role || []), 'superadmin', 'admin'].some(
                                (r) => item.name === r || item.name.startsWith(`${r}::`)
                            )
                        );
                        if (!hasRoles) {
                            const url = Object.keys(rolesUrls).reduce((acc, rol) => {
                                const isRole = data.some((item) => item.name === rol || item.name.startsWith(`${rol}::`));
                                if (isRole) {
                                    return rolesUrls[rol];
                                }
                                return acc;
                            }, '');
                            if (url) {
                                return navigateV2(url);
                            } else {
                                navigateV2('/error/403');
                            }
                        } else {
                            const data = await checkIsPartner(userToken, lang);
                            if (data?.data?.data) {
                                setProfileData(data?.data?.data);
                                setLoaded(true);
                            } else {
                                if (data === 401) {
                                    logOutFunction();
                                } else {
                                    setProfileData({});
                                    setLoaded(true);
                                }
                            }
                        }
                    } else {
                        if (status === 401) {
                            logOutFunction();
                        } else {
                            navigateV2(`/error/${status || 500}`);
                        }
                    }
                })();
            }
        }
    }, [lang, newToken, role, userToken, storageLoaded]);

    useHistoryStore(hasRoles, 'admin');
    if (!userToken || !hasRoles) return null;
    return (
        <PusherContext.Provider value={{ pusherClient }}>
            <UserProfileContext.Provider value={{ roles, profileData, loaded, adminPage: true, setNewToken }}>
                {children}
                <CustomPasswordModal />
            </UserProfileContext.Provider>
        </PusherContext.Provider>
    );
};

ProtectedAdmin.propTypes = { role: PropTypes.array };

export default ProtectedAdmin;
